import * as EFoodChoices from '../services/api/requests/EFoodChoices'
import { sortDataAlphabetically } from '../services/sortData'

export const doGetAllMalls = setMallList => {
  EFoodChoices.getAllMalls()
    .then(response => {
      setMallList({
        malls: response.data,
        mallList: response.data.map(mall => ({
          name: mall.name,
          value: mall.mallSlugName,
        })),
      })
    })
    .catch(() => {})
}

export const doGetAllBrands = ({ accessToken }) => setStores => {
  // REMOVED - getAllBrands function no longer exists
  // EFoodChoices.getAllBrands(accessToken).then(response => {
  //   const { data } = response
  //   setStores({
  //     stores: data.sort(sortDataAlphabetically),
  //   })
  // })
  setStores({
    stores: [],
  })
}

export const doGetEfoodChoices = ({ accessToken }) => ({
  setStores,
  mallSlug,
}) => {
  EFoodChoices.getAllRestaurants(mallSlug, accessToken).then(response => {
    const { data } = response
    let stores = [],
      storesNearby = []

    data.sort(sortDataAlphabetically).forEach(store => {
      if (store.nearMall) storesNearby.push(store)
      else stores.push(store)
    })

    setStores({
      stores,
      storesNearby,
    })
  })
}

export const doGetEFoodChoicesFeatured = ({ accessToken }) => ({
  mallSlug,
  setStores,
}) => {
  EFoodChoices.getAllRestaurants(mallSlug, accessToken).then(response => {
    const { data } = response
    setStores({
      stores: data
        .sort(sortDataAlphabetically)
        .filter(store => !store.nearMall),
      storeList: data
        .sort(sortDataAlphabetically)
        .filter(store => !store.nearMall),
    })
  })
}

export const doGetEFoodChoicesNearby = ({ accessToken }) => ({
  mallSlug,
  setStores,
}) => {
  EFoodChoices.getAllNearbyRestaurants(mallSlug, accessToken).then(response => {
    const { data } = response
    setStores({
      stores: data.sort(sortDataAlphabetically),
      storeList: data.sort(sortDataAlphabetically),
    })
  })
}
